import { jsx as _jsx } from "react/jsx-runtime";
function SvgTriangleDownIcon(props) {
    return (_jsx("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { d: "M11.1251 19.5011L3.12061 5.3961C2.7624 4.76487 3.24512 4 4.00171 4H19.9983C20.7546 4 21.2373 4.76435 20.8797 5.39556L12.8876 19.5006C12.5104 20.1662 11.5027 20.1665 11.1251 19.5011Z", fill: "currentColor" }, void 0) }), void 0));
}
export default SvgTriangleDownIcon;
